module.exports = __webpack_public_path__ + "d6fc6c237c19d93b557ebe9960749f56.MP3";